import { API_BASE_URL } from "../Common/Common";

// Photo-quality fix (2026-09-05) — see
// src/dataBase/api-dev/hasdata_places_photo.php's comment for the full
// story. Re-added same day after briefly being replaced by Scrape.do, kept
// alongside it for a direct in-app speed/quality comparison — measured
// ~1.2-2.2s/call here vs. Scrape.do's ~4.8-5.2s/call.
export default class HasDataPlaces {
  // query: a specific search string, e.g. "Eiffel Tower, Paris" — a plain
  // place name plus city/country gives HasData's search the best chance of
  // returning that exact place as its first result. lat/lng (optional) geo-
  // bias the search via HasData's `ll` param — important for common place
  // names ("Pizza", "Coffee Shop") where an unscoped search could match the
  // wrong city entirely.
  static searchPlacePhoto = (query, callback, lat, lng) => {
    if (!query) {
      callback(null);
      return;
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    fetch(`${API_BASE_URL}/hasdata_places_photo.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, lat, lng }),
      signal: controller.signal,
    })
      .then((r) => r.json())
      .then((data) => {
        clearTimeout(timeoutId);
        callback(data && data.photo ? data.photo : null);
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        console.log("HasDataPlaces.searchPlacePhoto error:", err);
        callback(null);
      });
  };
}
